import { useEffect, useState } from 'react';
import { SignJWT } from 'jose';

const JWT_SECRET = '2u0O4I&>m|n|5P"Nwvi0SlimSteam#';
const REDIRECT_BASE_URL = 'https://lovescape.com/character-pro/avatar/';

const HEADINGS = {
  female: 'Creating Your Female Character...',
  male: 'Creating Your Male Character...',
  trans: 'Creating Your Trans Character...',
  creature: 'Creating Your Creature Character...'
};

const SUBTEXTS = {
  female: 'Preparing her for the Lovescape universe.',
  male: 'Preparing him for the Lovescape universe.',
  trans: 'Preparing them for the Lovescape universe.',
  creature: 'Preparing her for the Lovescape universe.'
};

const Step5Final = ({ formData }) => {
  const [isCreating, setIsCreating] = useState(true);
  
  const heading = HEADINGS[formData.gender] || 'Creating Your Character...';
  const subtext = SUBTEXTS[formData.gender] || 'Preparing for the Lovescape universe.';

  useEffect(() => {
    const createCharacter = async () => {
      try {
        // Wait 2 seconds for loading animation
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Prepare JWT payload
        const jwtPayload = {
          gender: formData.gender === 'trans' ? 'transwoman' : (formData.gender === 'creature' ? 'female' : formData.gender),
          imageStyle: 'anime',
          safetyLevel: formData.safetyLevel,
          age: formData.age,
          extraFields: formData.extraFields
        };

        // Add promptType for trans and creature
        if (formData.gender === 'trans') {
          jwtPayload.promptType = 'trans';
        } else if (formData.gender === 'creature') {
          jwtPayload.promptType = 'creature';
        }
        
        // Generate JWT token using jose
        const secret = new TextEncoder().encode(JWT_SECRET);
        const token = await new SignJWT(jwtPayload)
          .setProtectedHeader({ alg: 'HS256' })
          .setExpirationTime('24h')
          .sign(secret);
        
        // Automatically redirect to the target URL with query parameters
        const redirectUrl = `${REDIRECT_BASE_URL}${token}?userId=c2f1936c0214a49d58880b116c336124034d7a2a06705b627765a7c90f586a25&sourceId=animered`;
        window.location.href = redirectUrl;
      } catch (error) {
        console.error('Error generating JWT:', error);
        setIsCreating(false);
        alert('Error creating character. Please try again.');
      }
    };

    createCharacter();
  }, [formData]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      textAlign: 'center',
      position: 'relative'
    }}>
      {/* Background images */}
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/s2zgc1ad_nowings.png" 
        alt="Background Left" 
        className="bg-image-left"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/h9eorbzw_female6.png" 
        alt="Background Right" 
        className="bg-image-right"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/i4w18itu_9.png" 
        alt="Background Center" 
        className="bg-image-center"
      />

      <h1 style={{
        fontSize: 'clamp(36px, 6vw, 56px)',
        marginBottom: '40px',
        letterSpacing: '4px',
        color: '#DA3D57',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 1
      }} data-testid="step5-heading">
        {heading}
      </h1>

      <p style={{
        fontSize: 'clamp(24px, 4vw, 36px)',
        marginBottom: '80px',
        letterSpacing: '1px',
        maxWidth: '800px',
        color: '#DA3D57',
        position: 'relative',
        zIndex: 1
      }} data-testid="step5-subtext">
        {subtext}
      </p>

      {isCreating && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '30px',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            border: '6px solid #DA3D57',
            borderTop: '6px solid transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
          <p style={{
            fontSize: '28px',
            letterSpacing: '2px',
            color: '#DA3D57'
          }}>
            Loading...
          </p>
        </div>
      )}
    </div>
  );
};

export default Step5Final;
